<template>
  <div class="page-box">
    <van-overlay class="box-center" :show="dialogLoading">
      <van-loading type="spinner" size="40px" vertical>正在核验中...</van-loading>
    </van-overlay>
    <step :index="2"></step>
    <div v-if="form.reportUrl">
      <div class="photo-box">
        <img class="photo-img" :src="form.reportUrl" width="100%" alt="" @click="onImagePreview(form.originUrl)"/>
      </div>
      <ul class="step-ul">
        <li class="li">
          1.背景须为纯白色(如垫A4纸)，确保证件摆放端正；
        </li>
        <li class="li">
          2.证件拍摄件应干净、字迹清晰，避免出现模糊、反光等影响识别的图片；
        </li>
        <li class="li">
          3.只能使用原件拍摄，不允许使用复印件或屏幕翻拍。
        </li>
      </ul>
      <div class="photo-info">
        <div class="info-title">确认快应用负责人信息</div>
        <div class="info-msg">若信息有误请重新拍摄识别，若信息正确请确认信息</div>
      </div>
      <div class="form-box" v-if="form.expire">
        <div class="item">
          <div class="label">证件有效期</div>
          <div class="value" @click.prevent="showPopup=true">
            {{ form.expire }}
          </div>
          <van-calendar 
            type="range" 
            color="#4285f5" 
            v-model="showPopup" 
            :default-date="dateList" 
            :min-date="minDate"
            :max-date="maxDate" 
            @confirm="onConfirm" />
        </div>
      </div>
      <div class="button-box">
        <van-uploader class="btn" :before-read="onBeforeRead" :after-read="onAfterRead">
          <van-button type="primary" class="btn" accept="image/*">重新上传</van-button>
        </van-uploader>
        <div class="margin-r20"></div>
        <van-button type="primary" class="btn" @click.prevent="onSubmit">确认信息</van-button>
      </div>
    </div>
    <div v-else>
      <div class="camera-box">
        <img class="camera-icon" src="@/assets/img/filing/camera.png" alt="">
        <div class="camera-msg">请拍摄快应用负责人{{$store.getters["filingStore/getInfo"]['rpkFzrXm']}}的身份证（国徽面）</div>
      </div>
      <ul class="step-ul">
        <li class="li">
          1.背景须为纯白色(如垫A4纸)，确保证件摆放端正；
        </li>
        <li class="li">
          2.证件拍摄件应干净、字迹清晰，避免出现模糊、反光等影响识别的图片；
        </li>
        <li class="li">
          3.只能使用原件拍摄，不允许使用复印件或屏幕翻拍。
        </li>
      </ul>
      <van-uploader class="button-box" :before-read="onBeforeRead" :after-read="onAfterRead">
        <van-button type="primary" class="btn" accept="image/*">上传照片</van-button>
      </van-uploader>
    </div>
  </div>
</template>
<script>
import {ImagePreview} from 'vant';
import Step from '../components/Step.vue'
export default {
  components:{
    Step,
  },
  data() {
    return {
      dialogLoading:false,
      imageUrl: '', 
      date:null,
      showPopup:false,
      form:{
        expire: "", 
        originUrl: '', 
        reportUrl: '', 
        rotateUrl: '', 
      }
    };
  },
  computed: {
    dateList(){
      return [new Date(this.form.expire.split(',')[0]),new Date(this.form.expire.split(',')[1])] ;
    },
    minDate(){
      let minDate = this.form.expire.split(',')[0];
      let dateTime = new Date(minDate).getFullYear(); 
      return new Date(new Date().setFullYear(dateTime-1))
    },
    maxDate(){
      if(this.form.expire.split(',')[1]){
        let minDate = this.form.expire.split(',')[1];
        let dateTime = new Date(minDate).getFullYear(); 
        return new Date(new Date().setFullYear(dateTime+1))
      }else{
        let minDate = this.form.expire.split(',')[0];
        let dateTime = new Date(minDate).getFullYear(); 
        return new Date(new Date().setFullYear(dateTime+100));
      }
    },
  },
  created(){
    const details = this.$store.getters["filingStore/getDetails"];
    if(details.isSamePerson){
      this.queryVerifing();
    }
  },
  methods: {
    // 查看当前核验进度
    queryVerifing(){
      this.$apis.filingServer.queryVerifing({
        filingsRecordCode: localStorage.getItem('filingsRecordCode'),
        userAgent: localStorage.getItem('userAgent'),
      }).then(res => {
        this.dialogLoading = false;
        if (res['code'] == 0) {
          const accountBack = JSON.parse(res['data'].accountBack);
          Object.assign(this.form,accountBack);
        }
      });
    },
    onConfirm(date) {
      const [start, end] = date;
      this.showPopup = false;
      this.form.expire = `${this.utils.parseTime(start,'{y}/{m}/{d}')},${this.utils.parseTime(end,'{y}/{m}/{d}')}`;
    },
    //上传前限制图片：返回布尔值
    onBeforeRead(file) {
      if (file.type !== 'image/jpeg' && file.type !== 'image/png') {
        this.$dialog.alert({
          message: '请上传图片',
          confirmButtonColor:'#4285f5',
        });
        return false;
      }
      return true;
    },
    //上传后：识别图片信息
    onAfterRead(res){
      this.dialogLoading = true;
      this.$apis.filingServer.uploadFile({
        uploadType:72,
        verifyToken:localStorage.getItem('verifyToken'),
        userAgent:localStorage.getItem('userAgent'),
        file:res.file,
      }).then(res=>{
        if (res['code'] == 0) {
          this.getPersonInfo(res['data']['originUrl'],res['data']['reportUrl']);
        } else {
          this.dialogLoading = false;
          this.$dialog.alert({
            message: res['msg'],
            confirmButtonColor:'#4285f5',
          });
        }
      })
    },
    //获取证件信息
    getPersonInfo(originUrl,reportUrl){
      this.$apis.filingServer.getPersonInfo({
        verifyToken:localStorage.getItem('verifyToken'),
        userAgent:localStorage.getItem('userAgent'),
        reportUrl,
        legalPerson:localStorage.getItem('legalPerson'),
        type:2,//1 正面 2 反面
      }).then(res=>{
        this.dialogLoading = false;
        if (res['code'] == 0) {
          if(res['data']['expire']){
            this.form.originUrl=originUrl, 
            this.form.reportUrl=reportUrl, 
            Object.assign(this.form,res['data']);
          }else{
            this.$dialog.alert({
              message: '证件图片核验未通过，请重新上传',
              confirmButtonColor:'#4285f5',
            });
          }
        } else {
          this.$dialog.alert({
            message: res['msg'],
            confirmButtonColor:'#4285f5',
          });
        }
      })
    },
    onImagePreview (url) {
      ImagePreview([ url ]);
    },
    onSubmit(){
      this.$dialog.confirm({
        message: `注意:请一定确保是原件拍摄，若是屏幕翻拍不仅核准将被退回，还将被延时审核(至少10个工作日)，后果严重!`,
        confirmButtonText:'提交',
        confirmButtonColor:'#4285f5',
        cancelButtonText:'取消',
        cancelButtonColor:'#4285f5',
      })
      .then(() => {
        this.dialogLoading = true;
        const query = this.$route.query;
        this.$apis.filingServer.verifyAccountBackInfo({
          verifyToken:localStorage.getItem('verifyToken'),
          userAgent:localStorage.getItem('userAgent'),
          ...this.form,
          type:2,//1 主体负责人 2 快应用负责人
        }).then(res=>{
          this.dialogLoading = false;
          if (res["code"] == 0) {
            if(res["data"]){
              this.$router.push({ path: '/filing/process/quickApp/faceliveness', query });
            }else{
              this.$dialog.alert({
                message: '您的快应用负责人信息与之前填写的不一致，请核对信息后重新填写。',
                confirmButtonColor:'#4285f5',
              });
            }
          } else {
            this.$dialog.alert({
              message: res['msg'],
              confirmButtonColor:'#4285f5',
            });
          }
        })
      })
      .catch(() => {
        // on cancel
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.page-box {
  max-width: 750px;
  margin: auto;
  padding: 50px;
  .camera-box{
    margin: auto;
    margin-top: 40px;
    padding: 50px;
    border: 1px solid rgba(215, 215, 215, 1);
    border-radius: 10px;
    .camera-icon{
      display: block;
      margin: auto;
      width: 250px;
    }
    .camera-msg{
      text-align: center;
      color: #ccc;
    }
  }
  .photo-box{
    margin-top: 40px;
  }
  .step-ul{
    margin-top: 20px;
    color: #ccc;
    .li{
      line-height: 38px;
    }
  }
  .photo-info{
    margin-top: 40px;
    .info-title{
      font-size: 28px;
      font-weight: bold;
    }
    .info-msg{
      margin-top: 20px;
      margin-bottom: 50px;
      font-size: 26px;
      color: #ccc;
    }
  }
  .form-box{
    margin-top: 30px ;
    .value{
      margin: 20px 0;
      padding: 20px 10px;
      width: 100%;
      border:2px solid #ccc;
      border-radius: 2px;
    }
  }
  .button-box{
    position: relative;
    display: flex;
    justify-content: center;
    margin-top: 40px;
    .btn{
      flex: 1;
      display: flex;
      justify-content: center;
      background-color: #4285f5;
      border-color: #4285f5;
      border-radius: 10px;
    }
  }
}
</style>
